/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const HR = ({
  className,
  isDashed = false,
}: {
  className?: string;
  isDashed?: boolean;
}) => {
  return (
    <div
      className={cn(
        "w-full border-t -border--theme-colors-border-neutral-11 my-5",
        { "border-dashed": isDashed },
        className,
      )}
    />
  );
};

export default HR;
